import { tracked } from "@supergrain/kernel/react"
import CardStackProvider from "react-app/components/planner/card-stacks/CardStackProvider"
import DateRow from "react-app/components/planner/course/outline-and-detail/DateRow"

interface Props {
  courseId: string
  planbookId: string
  rotationCalendarId: string
  dateString: string
  /** How deep this date sits inside units — drives the row's indent class. */
  unitDepth: number
  hasFocus: boolean
  canBeEditable: boolean
  isSelectable: boolean
  selectedDateStrings: Array<string>
  onLessonSelect?: (cardStackId: string | null, dateString: string) => void
  onFocusIn?: () => void
  arrowUpDown: (direction: "up" | "down") => void
}

/** The Ember `Provider` + `DateRow` pair, as a React island. */
export default tracked(function OutlineDateRowIsland({
  courseId,
  planbookId,
  rotationCalendarId,
  dateString,
  unitDepth,
  hasFocus,
  canBeEditable,
  isSelectable,
  selectedDateStrings,
  onLessonSelect,
  onFocusIn,
  arrowUpDown,
}: Props) {
  return (
    <CardStackProvider
      courseId={courseId}
      planbookId={planbookId}
      rotationCalendarId={rotationCalendarId}
      dateString={dateString}
      useCardStackSummary={true}
    >
      {(courseDate, cardStack, _units, cardStackIsFulfilled, course, planbook, rotationCalendar) =>
        !cardStackIsFulfilled || cardStack === null ? null : (
          <DateRow
            key={courseDate.dateString}
            courseDateCardStackId={courseDate.cardStackId}
            cardStack={cardStack}
            course={course}
            planbook={planbook}
            rotationCalendar={rotationCalendar}
            dateString={dateString}
            unitDepth={unitDepth}
            hasFocus={hasFocus}
            canBeEditable={canBeEditable}
            isSelectable={isSelectable}
            selectedDateStrings={selectedDateStrings}
            onLessonSelect={onLessonSelect}
            onFocusIn={onFocusIn}
            arrowUpDown={arrowUpDown}
          />
        )
      }
    </CardStackProvider>
  )
})
